import type {
	CustomItem,
	DropGalleryType,
	Item,
} from '#lib/features/drop-page/constants/types.js';

export const isDropGallery = (
	item: Item | CustomItem
): item is DropGalleryType => {
	return !!(item && item.__typename === 'Drop_Gallery');
};
